<template>
    <div style="width:100%;margin:0 auto;overflow:hidden" class="relative" :style="minHeight">
        <iframe id="show-iframe" ref="iframe" title="Report Section" src="https://app.powerbi.com/view?r=eyJrIjoiMDU0NmI4YTUtZTQ3MS00M2I3LTkxNmYtN2EyM2ZkZWQxYjI5IiwidCI6IjY0ZjMzNDMxLWJiZjAtNDJiOC04MmVmLWJmNDUxYmQwZDg1ZCJ9" frameborder="0" scrolling="yes" class="absolute" style="overflow:hidden;background-color:transparent;width: 100%;
         height:100%; top: 0px;left:0;bottom:0;padding:10px;" />
    </div>
</template>

<script>
export default {
  name: 'BusinessInventoryReport',
  data() {
    return {
      minHeight: ''
    };
  },
  created() {
    var h = document.documentElement.clientHeight - 100;
    this.minHeight = 'height:' + h + 'px;';
  }
};
</script>
